import { ACCLOADING } from "./types"

const accLoadingFetch = () => ({
    type: ACCLOADING.FETCH
})

const accLoadingFinish = () => ({
    type: ACCLOADING.FINISH
})

export {accLoadingFetch, accLoadingFinish}